import { isEmbarcacaoVelocidadeConsumoEmpty } from "@/modules/embarcacoes/embarcacoes.types";
import type {
  EmbarcacaoVelocidadeConsumo,
  EmbarcacaoVelocidadeConsumoState,
} from "@/modules/embarcacoes/embarcacoes.types";
import {
  useEmbarcacaoDetailSection,
  type EmbarcacaoDetailSectionQuery,
} from "./use-embarcacao-detail-section";

const VELOCIDADE_CONSUMO_QUERY: EmbarcacaoDetailSectionQuery<EmbarcacaoVelocidadeConsumo> = {
  select: (ficha) => ficha.velocidadeConsumo,
  isEmpty: isEmbarcacaoVelocidadeConsumoEmpty,
  secao: "a Velocidade e Consumo",
};

interface UseEmbarcacaoVelocidadeConsumoResult extends EmbarcacaoVelocidadeConsumoState {
  reload: () => void;
}

/** Consulta a Velocidade e Consumo da embarcação pedida. Somente leitura. */
export function useEmbarcacaoVelocidadeConsumo(id: string): UseEmbarcacaoVelocidadeConsumoResult {
  const { data, ...state } = useEmbarcacaoDetailSection(id, VELOCIDADE_CONSUMO_QUERY);

  return { ...state, velocidadeConsumo: data };
}
